/* eslint-disable consistent-return */
import { Flex, Pane, Text } from '@leverege/ui-elements'
import React from 'react'
import usePaceOverviewCards from '../hooks/usePaceOverviewCards'
import S from './OverallPaceCard.css'
import { formatPaceTimes } from './Utils'

const icons = {
  Good : 'fa-solid fa-check',
  Bad : 'fa-solid fa-xmark',
}

function OverallPaceCard( { fgJob } ) {
  const {
    paces : { overall },
  } = usePaceOverviewCards( fgJob )

  return (
    <Pane
      variant="factoryDashboardCardCustom"
      style={{ minWidth : 160, overflow : 'hidden' }}>
      <Pane variant="overallDashboardCardCustomHeader" style={{ display : 'flex', alignItems : 'center', flexFlow : 'column wrap' }}>
        <Text variant="overallPaceCardHeader" style={{ flex : 1 }}>
          {overall.title}
        </Text>
        {overall.completed && <Text variant={`tag${overall.status}`}>Completed</Text>}
      </Pane>
      <Pane
        variant="overallDashboardCardCustomArea"
        style={{ minWidth : 160, height : `calc(100% - ${overall.completed ? '129px' : '103px'})` }}
        className={S[`cardArea${overall.status}`]}>
        <Flex
          variant="col"
          gap={20}
          style={{
            height : '100%',
            justifyContent : 'space-around',
          }}>
          <Text
            style={{
              fontSize : 50,
              alignSelf : 'center',
              paddingTop : 16,
            }}>
            <i className={icons[overall.status]} />
          </Text>
          <Flex variant="colM">
            <Text
              variant="overallPaceCardDetailHeader"
              class={S.paceDetailHeader}>
              CT
            </Text>
            <Text variant="factoryOverallPace">{overall.currentPace}</Text>
          </Flex>
          <Pane variant="overallDetailBox" className={S.detailBox}>
            <Flex variant="colL">
              <Text variant="overallPaceCardDetailHeaderSmall">Target CT</Text>
              <Text variant="overallPaceCardDetailContent">
                {overall.targetPace}
              </Text>
            </Flex>
          </Pane>
          <Pane variant="overallDetailBox" className={S.detailBox}>
            <Flex variant="colL">
              <Text variant="overallPaceCardDetailHeaderSmall">
                CT Difference
              </Text>
              <Text
                variant="overallPaceCardDetailContent"
                className={S[`paceCardDetailContent${overall.status}`]}>
                {formatPaceTimes( overall.currentPace - overall.targetPace, {
                  signDisplay : 'always',
                } )}
              </Text>
            </Flex>
          </Pane>
        </Flex>
      </Pane>
    </Pane>
  )
}
export default OverallPaceCard
